<template>
  <QueryFilter @search="onSearch" />
  <div class="list">
    <div v-for="item of list" :key="item.id" class="item">
      <div class="head">
        <span class="lottery">{{ item.lotteryName }}</span>
        <span class="periods">#{{ item.periods }}</span>
      </div>
      <div class="body">
        <div class="left">
          <div class="lb">{{ $t('query.number') }}</div>
          <div class="num">{{ pad(item.num) }}</div>
        </div>
        <div class="right">
          <div class="lb">{{ $t('query.amount') }}</div>
          <div class="amt">₡{{ item.mAmount + item.rAmount }}</div>
        </div>
      </div>
    </div>
    <div v-if="list.length < total" class="load-more" @click="getMore">{{ $t('common.loadMore') }}</div>
    <div v-if="list.length === 0" class="empty">
      <van-icon name="records" class="empty-icon" />
      <div>{{ $t('common.noData') }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { LotteryService } from '@/services';
import QueryFilter from './QueryFilter.vue';

const list = ref([]);
const total = ref(0);
const pageNumber = ref(1);
const isQuery = ref(false);
const filter = ref({ startTime: '', endTime: '' });
const pad = (n) => String(n).padStart(2, '0');

const initResult = async () => {
  const { result } = await LotteryService.getLotteryDrawApi({
    pageNumber: pageNumber.value,
    startTime: filter.value.startTime,
    endTime: filter.value.endTime,
  });
  if (isQuery.value) {
    list.value = result.data || [];
    isQuery.value = false;
  } else if (result.data && result.data.length) {
    list.value = [...list.value, ...result.data];
  } else if (pageNumber.value === 1) {
    list.value = [];
  }
  total.value = result.total;
};
const getMore = () => {
  pageNumber.value += 1;
  initResult();
};
const onSearch = (v) => {
  isQuery.value = true;
  pageNumber.value = 1;
  filter.value = v;
  initResult();
};
onMounted(initResult);
</script>

<style lang="scss" scoped>
.list {
  padding: 0 16px;
}
.item {
  background: #fff;
  border-radius: 16px;
  padding: 20px 24px;
  margin-bottom: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    .lottery {
      font-size: 28px;
      font-weight: 600;
      color: var(--text-primary);
    }
    .periods {
      color: var(--brand-primary);
      font-size: 22px;
      font-weight: 500;
      background: var(--brand-light);
      padding: 4px 10px;
      border-radius: 999px;
    }
  }
  .body {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .lb {
      font-size: 20px;
      color: var(--text-muted);
      margin-bottom: 4px;
    }
    .num {
      font-size: 48px;
      font-weight: 700;
      color: var(--brand-secondary);
      font-family: 'Menlo', 'Consolas', monospace;
      line-height: 1.1;
    }
    .amt {
      font-size: 32px;
      font-weight: 700;
      color: #10b981;
    }
    .right {
      text-align: right;
    }
  }
}
.load-more {
  text-align: center;
  color: var(--brand-primary);
  font-size: 26px;
  padding: 24px;
  cursor: pointer;
}
.empty {
  text-align: center;
  color: var(--text-muted);
  padding: 120px 0;
  font-size: 26px;
  .empty-icon {
    font-size: 100px;
    margin-bottom: 16px;
    opacity: 0.5;
  }
}
</style>
